import { Link, Stack, Typography } from "@mui/material";

import { CopyCodeBlock } from "../../../../Components/CopyCodeBlock/CopyCodeBlock";

const SNOWFLAKE_FIXED_IPS = ["34.121.183.173", "34.134.157.59", "34.134.111.192", "34.69.217.183", "35.192.89.77"];

export default function SnowflakeStepIPFiltering() {
  return (
    <Stack spacing={4} data-cy="step-ip-filtering" sx={{ pb: 5 }}>
      <Typography variant="h1">Restrict access to specific IP addresses (optional)</Typography>

      <Typography variant="body1">
        If you have a network policy that restricts connections to Snowflake from a specific range of IP addresses (IP
        allowlisting), we use Google Cloud VPC and Cloud NAT to ensure that all outgoing requests to Snowflake are
        routed through specific IP addresses.
      </Typography>

      <Typography variant="body1">
        Add a network rule to your{" "}
        <Link href="https://docs.snowflake.com/en/user-guide/network-policies" target="_blank" underline="none">
          Snowflake network policy
        </Link>{" "}
        that allows the following IP addresses:
      </Typography>

      <CopyCodeBlock base={SNOWFLAKE_FIXED_IPS.join("\n")} maxHeight={200} />
    </Stack>
  );
}
